import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001" //"https://chrisonsite-api-c1c0b341a4c3.herokuapp.com";

const motorcycleSuper = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/motorcycle-super.png";
const sedanSuper = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/sedan-super.png";
const suvSuper = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/suv-super.png";
const oversizedSuper = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/oversized-super.png";

const sedanHouse = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/sedan-house.png";
const suvHouse = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/suv-house.png";
const oversizedHouse = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/oversize-house.png";

const motorcycleBasic = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-motorcycle.png";
const sedanBasic = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-sedan.png";
const suvBasic = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-suv.png";
const oversizedBasic = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wash-oversized.png";

const addOneWheel = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addTwoWheels = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addThreeWheels = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addFourWheels = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/wheel-addon.png";
const addOneHeadlight = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/headlight-addon.png";
const addTwoHeadlights = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/headlight-addon.png";
const addonLeather = "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/leather-addon.png";


let checkoutImages = {
    "motorcycleSuper": motorcycleSuper,
    "sedanSuper": sedanSuper,
    "suvSuper": suvSuper,
    "oversizedSuper": oversizedSuper,
    "sedanHouse": sedanHouse,
    "suvHouse": suvHouse,
    "oversizedHouse": oversizedHouse,
    "motorcycleBasic": motorcycleBasic,
    "sedanBasic": sedanBasic,
    "suvBasic": suvBasic,
    "oversizeBasic": oversizedBasic,
    "oversizeSuper": oversizedSuper,
    "oversizeHouse": oversizedHouse,
    "addOneWheel": addOneWheel,
    "addTwoWheels": addTwoWheels,
    "addThreeWheels": addThreeWheels,
    "addFourWheels": addFourWheels,
    "addOneHeadlight": addOneHeadlight,
    "addTwoHeadlights": addTwoHeadlights,
    "addFullLeatherRestore": addonLeather,
    "leather": addonLeather,
    "basicWash": "https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png",
};

const Checkout = async () => {
    
  const [loaded, setLoaded] = useState(false);
  
  let StripePubKey = "pk_live_51SrVAvGR8Ubngl25pGN8qFEfrpJqO5bcFSoShOamYSK4ldAGB7wxBShY1mLUs5R4Ee9Hd0Kvg7WYnvigxpafvSWr00MkSiHtwS";
  const stripe = window.Stripe(StripePubKey);

  const { serviceType } = useParams();

  const handleError = (error) => {
    window.location.replace("/error?error="+error);
  };


  // Initialize Stripe Checkout
  const showCheckoutPage = async () => {

    let response2;

    try {
        response2 = await fetch(API_URL+"/stripe/create-checkout-session", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ 
            serviceType: serviceType
          })
        });
      } catch (error) {
        console.error("Error creating checkout session:", error);
        return;
      }

      if(response2.status !== 200) {
        console.error("Failed to create checkout session");
        handleError();
        return;
      }

      const data = await response2.json();

      let { success, paid, active, stripe_checkout_session_id, stripe_checkout_client_secret } = data;
    

      if(success) {

        const checkout = await stripe.initEmbeddedCheckout({
          clientSecret: stripe_checkout_client_secret
        });

        const checkoutSession = { ...checkout.embeddedCheckout };

        stripe_checkout_session_id = checkoutSession.checkoutSessionId;

        setLoaded(true);

        checkout.mount('#checkout-element');

        return;
      }
        
      // Initialize Embedded Checkout
      if (!stripe) {
        console.error("Stripe.js failed to load.");
        return;
      }

  }

    // Check if Stripe is loaded
  useEffect(() => {
    if (!window.Stripe) {
      console.error("Stripe.js is not loaded. Make sure the Stripe script is included in your index.html before your app scripts.");
    } else {
      console.log("Stripe.js loaded successfully.");
      showCheckoutPage();
    }
  }, []);

  return (
    <>
        {!loaded && (
            <div style={{ position: "relative", display: "block", textAlign: 'center', minHeight: "100vh", width: "100vw" }}>
            <div style={{position: "absolute", width: "200px", height: "auto", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
                <img src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png" alt="Chris Details Cars Logo" className="descriptor-image" style={{width: "120px", height: "auto"}} />
            </div>
            </div>
        )}
        <section className="checkout-body-section">
            <div id="checkout-element-imagery"></div>
            <div id="checkout-element">
                {/*Checkout will insert the payment form here*/}
            </div>
        </section>
    </>
  );

};

export default Checkout;
// Note: The above code assumes that the Stripe.js library and the checkout.js script are loaded correctly.
// The checkout.js script should handle the Stripe payment processing and mount the checkout form into the #checkout div.
// Ensure that the Stripe API key and other configurations are set up correctly in your environment.